var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _g, _line, _line2, _line3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBharatpeRefundService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paymentGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a3d4d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a5f6f",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#paymentGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 60,
    width: 100,
    height: 80,
    rx: 10,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 60,
    width: 100,
    height: 30,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 80,
    r: 8,
    fill: "#00ff88",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 100,
    r: 8,
    fill: "#00ff88",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 120,
    r: 8,
    fill: "#00ff88",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "none",
    stroke: "#00ff88",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -15 0 L -5 10 L 15 -10",
    stroke: "#00ff88",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 250,
    x2: 150,
    y2: 250,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 250,
    x2: 220,
    y2: 250,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 250,
    x2: 350,
    y2: 250,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 250,
    r: 3,
    fill: "#00ffff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 250,
    r: 3,
    fill: "#00ff88"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 250,
    r: 3,
    fill: "#00ff88"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 250,
    r: 3,
    fill: "#00ffff",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBharatpeRefundService);
export default __webpack_public_path__ + "static/media/bharatpe_refund_service.87a4a5edc69354215f6aff6befdf74dd.svg";
export { ForwardRef as ReactComponent };